export default "__VITE_ASSET__I_i442xF__"